import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom'; // Přidáno pro odkaz na GDPR stránku
import { API_ENDPOINTS } from '../apiConfig';

const ContactPage = () => {
  const [status, setStatus] = useState('idle');
  const [formData, setFormData] = useState({
    jmeno: '',
    email: '',
    projekt: '',
    gdpr: false, // Nové pole pro souhlas
    botField: ''
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ 
      ...formData, 
      [name]: type === 'checkbox' ? checked : value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.botField !== '') return;
    if (!formData.gdpr) {
      alert("Pro odeslání musíte souhlasit se zpracováním osobních údajů.");
      return;
    }

    setStatus('submitting');

    try {
      // POZNÁMKA: Tento požadavek musí zpracovat tvůj backend, 
      // který vezme tato data a pošle je na kolarikva@seznam.cz
      const response = await fetch(API_ENDPOINTS.CONTACT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          jmeno: formData.jmeno,
          email: formData.email,
          zprava: formData.projekt,
          prijemce: 'kolarikva@seznam.cz' // Instrukce pro tvůj backend
        }),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ jmeno: '', email: '', projekt: '', gdpr: false, botField: '' });
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div style={{ backgroundColor: '#f4e9dc', minHeight: '100vh', paddingTop: '140px', paddingBottom: '80px', color: '#2b1f18' }}>
      <div style={{ maxWidth: '1200px', margin: 'auto', padding: '0 20px' }}>
        
        <motion.h1 
          initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}
          style={{ textAlign: 'center', fontSize: 'clamp(2.5rem, 8vw, 3.5rem)', marginBottom: '50px', fontWeight: '800' }}
        >
          Pojďme něco vytvořit
        </motion.h1>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '40px' }}>
          
          {/* KONTAKTNÍ KARTA */}
          <motion.div 
            initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }}
            style={{ background: '#2b1f18', color: '#fff', padding: '40px', borderRadius: '25px', boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }}
          >
            <h2 style={{ color: '#d1b892', marginBottom: '30px', fontSize: '1.8rem' }}>Kontakt</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <p><strong>📍 Adresa:</strong><br />Příční 382/5, Svatobořice 696 04</p>
              <p><strong>✉️ Email:</strong><br /><a href="mailto:kolarikva@seznam.cz" style={{ color: '#d1b892', textDecoration: 'none' }}>kolarikva@seznam.cz</a></p>
              <p><strong>📞 Tel:</strong><br /><a href="tel:+420607935018" style={{ color: '#d1b892', textDecoration: 'none' }}>+420 607 935 018</a></p>
            </div>

            <div style={{ marginTop: '40px', overflow: 'hidden', borderRadius: '15px', height: '250px', border: '1px solid #444' }}>
              <iframe 
                title="mapa"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2621.464648785!2d17.0863!3d48.9884!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47132646c0a00001%3A0x123456789!2sP%C5%99%C3%AD%C4%8Dn%C3%AD%20382%2F5%2C%20696%2004%20Svatobo%C5%99ice-Mist%C5%99%C3%ADn!5e0!3m2!1scs!2scz!4v1700000000000" 
                width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy"
              ></iframe>
            </div>
          </motion.div>

          {/* FORMULÁŘ */}
          <motion.div 
            initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }}
            style={{ background: '#fff', padding: '40px', borderRadius: '25px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}
          >
            <AnimatePresence mode="wait">
              {status === 'success' ? (
                <motion.div 
                  key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }}
                  style={{ textAlign: 'center', padding: '40px 0' }}
                >
                  <div style={{ fontSize: '4rem', marginBottom: '20px' }}>✅</div>
                  <h3>Zpráva odeslána!</h3>
                  <p>Ozvu se vám hned, jak odložím dláto.</p>
                  <button onClick={() => setStatus('idle')} className="contact-button" style={{ marginTop: '20px' }}>Poslat další</button>
                </motion.div>
              ) : (
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  <input type="text" name="botField" style={{ display: 'none' }} tabIndex="-1" onChange={handleChange} value={formData.botField} />

                  <div>
                    <label style={labelStyle}>Vaše jméno</label>
                    <input type="text" name="jmeno" required placeholder="Jan Novák" style={inputStyle} onChange={handleChange} value={formData.jmeno} />
                  </div>

                  <div>
                    <label style={labelStyle}>E-mail</label>
                    <input type="email" name="email" required placeholder="vas@email.cz" style={inputStyle} onChange={handleChange} value={formData.email} />
                  </div>

                  <div>
                    <label style={labelStyle}>Váš projekt</label>
                    <textarea name="projekt" required placeholder="Popište mi svou představu..." rows="4" style={inputStyle} onChange={handleChange} value={formData.projekt}></textarea>
                  </div>

                  {/* GDPR CHECKBOX */}
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginTop: '10px' }}>
                    <input 
                      type="checkbox" 
                      name="gdpr" 
                      id="gdpr" 
                      required 
                      checked={formData.gdpr} 
                      onChange={handleChange}
                      style={{ marginTop: '5px', cursor: 'pointer' }}
                    />
                    <label htmlFor="gdpr" style={{ fontSize: '0.85rem', color: '#5a4935', cursor: 'pointer', lineHeight: '1.4' }}>
                      Souhlasím se zpracováním osobních údajů pro účely vyřízení této poptávky. 
                      Více informací na stránce <Link to="/gdpr" style={{ color: '#d1b892', fontWeight: 'bold' }}>GDPR</Link>.
                    </label>
                  </div>

                  <button 
                    className="contact-button" 
                    type="submit" 
                    disabled={status === 'submitting'}
                    style={{ 
                      cursor: status === 'submitting' ? 'not-allowed' : 'pointer',
                      opacity: status === 'submitting' ? 0.7 : 1,
                      border: 'none', padding: '18px'
                    }}
                  >
                    {status === 'submitting' ? 'Odesílám...' : 'Odeslat nezávaznou poptávku'}
                  </button>
                  
                  {status === 'error' && (
                    <p style={{ color: 'red', fontSize: '0.9rem', textAlign: 'center' }}>Něco se nepovedlo. Zkuste to znovu nebo napište na mail.</p>
                  )}
                </form>
              )}
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

const labelStyle = { display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '0.9rem', color: '#5a4935' };
const inputStyle = { width: '100%', padding: '15px', borderRadius: '12px', border: '1px solid #ddd', fontSize: '1rem', outlineColor: '#d1b892', boxSizing: 'border-box' };

export default ContactPage;